import { render, staticRenderFns } from "./article-review-carousel.vue?vue&type=template&id=1ac449bb&scoped=true"
import script from "./article-review-carousel.vue?vue&type=script&lang=js"
export * from "./article-review-carousel.vue?vue&type=script&lang=js"
import style0 from "./article-review-carousel.vue?vue&type=style&index=0&id=1ac449bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac449bb",
  null
  
)

export default component.exports